module.exports = __webpack_public_path__ + "img/motor_no41.463e4a87.jpg";